<template>
	<div>
		<Header></Header>
		<Nav></Nav>
		<div class="userbox">
			<div class="user">
				<!-- 面包屑 -->
				<div class="ttshop_ordernav clearfloat">
					<p class="ttshop_navtext" @click="goTtshop_user">活动管理</p>
				</div>
				<div class="userconter">
					<div class="userup" v-if="useror_list && useror_list.length">
						<div class="usertitle clearfloat">
							<p>商品名称</p>
							<p>消耗积分</p>
							<p>购买时间</p>
							<p>订单状态</p>
						</div>
						<div class="yhlist">
							<div class="ttshop-myordercon" v-for="(item,index) in useror_list" v-model="index">
								<div class="ttshop-myorderconed clearfloat">
									<div class="ttshop-myordercontitle clearfloat">
										<p>订单号：<span>{{item.order_no}}</span></p>
									</div>
									<div class=" clearfloat d-flex orderlist">
										<div class="listitem">
											<div class="ttshop-myorderconlist d-flex clearfloat" v-for="(items,idx) in item.goods_list" :key="idx">
												<div class="ttshop-myorderconleft clearfloat">
													<div class="ttshop-ordertext">
														<h5>{{items.goods_name}}</h5>
													</div>
												</div>
												<div class="ttshop-myorderdj ttshop-myorderdjer">
													<p><span>{{item.pay_price}}</span></p>
												</div>
												<div class="ttshop-myorderdj">
													<p><span>{{item.addtime}}</span></p>
												</div>
												<div class="ttshop-shr">
													<div>
														<p class="ttshop-over" v-if="item.apply_delete == 1">已取消</p>
														<p class="ttshop-over ttshop-over-examine" v-if="item.is_send == 0 && item.apply_delete == 0">待发货</p>
														<p class="ttshop-over ttshop-over-examine" v-if="item.is_send == 1 && item.is_confirm == 0">待收货</p>
														<p class="ttshop-over ttshop-over-adopt" v-if="item.is_confirm == 1">已收货</p>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="goods-paging d-flex align-items-center justify-content-center">
							<el-pagination background @current-change="handleCurrentChange" :current-page.sync="currentPage1" :page-size="limit"
							 :hide-on-single-page='true' layout="prev, pager, next, total, jumper" :total="ttshop_znum"></el-pagination>
						</div>
					</div>
					<template v-else>
						<div class="zanwugoods" v-if="datatype">
							<img src="../../../assets/images/ttshop_zanwu.png" alt="">
							<p>暂无用户订单</p>
						</div>
					</template>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from "@/components/purchase/header/header";
	import Nav from "@/components/purchase/nav/nav";
	import Footer from "@/components/purchase/footer/footer";
	
	export default {
		components: {
			Header,
			Nav,
			Footer,
		},
		data() {
			return {
				route_url: this.$route.params.route_url,
				userid: this.$route.query.id,
				ackid:  this.$route.query.ackid,
				datatype: false,
				currentPage1: 1, //页数
				ttshop_znum: 0, //总商品数
				limit: 20, //每页条数
				page_count: '', //总页数
				useror_list:[],
			}
		},
		created() {
			let that = this;
			that.userlist();
		},
		methods: {
		    goTtshop_user() {
		    	this.$router.push(this.common.qycgrouter(this) + "/activities");
		    },
			userlist(){
				this.datatype = false;
				this.$api.userlister({
					page: this.currentPage1,
					limit: this.limit,
					act_id: this.ackid,
					user_id: this.userid,
					type:0,
					status:0,
					shop_type: 'qycg',
					access_token: this.$store.state.qycg_user.access_token,
				}).then((res) => {
					console.log(res)
					this.useror_list = res.data.list;
					this.ttshop_znum = Number(res.data.row_count);
					this.page_count = res.data.page_count;
					this.datatype = true;
					
				}).catch((err) => {
					// console.log(err);
				});
			},
			// 输入分页
			handleCurrentChange(e) {
				this.currentPage1 = e;
				this.userlist();
			},
		},
	}
</script>

<style lang="scss" scoped>
	.zanwugoods {
		width: 100%;
		padding: 150px 0;
		box-sizing: border-box;
	
		img {
			display: block;
			width: 93px;
			height: 80px;
			margin: 0 auto 20px;
		}
	
		p {
			font-size: 16px;
			color: #333;
			text-align: center;
		}
	}
	.userbox{
		width: 100%;
		padding: 20px 0 40px 0;
		box-sizing: border-box;
		.user{width: 1080px;margin: 0 auto;}
		.ttshop_ordernav {
			width: 100%;
			margin-bottom: 20px;
			.ttshop_navtext {
				float: left;
				cursor: pointer;
				font-size: 12px;
				color: #333;
				transition: 0.5s;
				-moz-transition: 0.5s;
				-webkit-transition: 0.5s;
				-o-transition: 0.5s;
		
				&:hover {
					color: #ff0e25;
				}
			}
			span {
				float: left;
				font-size: 12px;
				color: #333;
				margin: 0 5px;
			}
			.ttshop_orderdh {
				float: left;
				font-size: 12px;
				color: #333;
		
				strong {
					font-size: 12px;
					color: #333;
					font-weight: 400;
				}
			}
		}
		.orderlist{width: 100%;}
		.listitem{width: 100%;}
		.userconter{
			width: 100%;
			.userup{
				width: 100%;
				.usertitle{
					width: 100%;
					height: 32px;
					background: #f5f5f5;
					line-height: 32px;
					margin-bottom: 12px;
					p{
						font-size: 12px;
						color: #333;
						float: left;
						width: 20%;
						text-align: center;
						&:nth-child(1){width: 50%;text-align: left;padding-left: 20px;box-sizing: border-box;}
						&:nth-child(2){width: 19%;}
						&:nth-child(3){width: 19%;}
						&:nth-child(4){width: 12%;}
					}
				}
				.yhlist{
					width: 100%;
					.ttshop-myordercon {
						width: 100%;
						
						.ttshop-myorderconed {
							width: 100%;
							margin-bottom: 20px;
						
							.ttshop-myordercontitle {
								width: 100%;
								height: 32px;
								background: #f5f5f5;
								padding: 0 20px;
								box-sizing: border-box;
								line-height: 32px;
						
								p {
									float: left;
									font-size: 12px;
									color: #999;
						
									span {
										font-size: 12px;
										color: #999;
									}
						
									strong {
										color: #333;
										font-weight: 500;
									}
								}
						
								& p:last-child {
									margin-right: 0;
									// float: right;
								}
						
								.ttshop-myordercontitle-right {
									float: right;
									line-height: 32px;
						
									.ttshop-cancel {
										font-size: 12px;
										color: #999;
										// margin-bottom: 2px;
									}
						
									.ttshop-over {
										font-size: 12px;
										color: #ff0e25;
										margin-right: 24px; 
										// margin-bottom: 2px;
									}
									.ttshop-over-adopt{
										color: green;
									}
									.ttshop-over-examine{
										color: #FF9010;
									}
						
									strong {
										font-size: 12px;
										color: #ff0e25;
										font-weight: 400;
										cursor: pointer;
									}
								}
							}
						
							.ttshop-myorderconlist {
								width: 100%;
								border-left: 1px solid #ebebeb;
								border-bottom: 1px solid #ebebeb;
								box-sizing: border-box;
								border-right: 0;
								border-top: 0;
						
								.ttshop-myorderconleft {
									float: left;
									width: 50%;
									padding: 16px 20px 16px 10px;
									box-sizing: border-box;
						
									.ttshop-orderimg {
										float: left;
										width: 80px;
										height: 80px;
										margin-right: 12px;
						
										img {
											display: block;
											width: 100%;
											height: 100%;
											object-fit: cover;
										}
									}
						
									.ttshop-ordertext {
										width: 100%;
						
										h5 {
											font-size: 12px;
											color: #333333;
											font-weight: 500;
											line-height: 18px;
											display: -webkit-box;
											-webkit-box-orient: vertical;
											-webkit-line-clamp: 2;
											overflow: hidden;
											margin-bottom: 8px;
										}
						
										span {
											font-size: 12px;
											color: #999;
											margin-right: 5px;
						
											strong {
												font-weight: 400;
												font-size: 12px;
												color: #999;
											}
										}
									}
								}
						
								.ttshop-myorderdj {
									float: left;
									width: 19%;
									text-align: center;
									border-right: 1px solid #ebebeb;
									padding-top: 16px;
									box-sizing: border-box;
						
									p {
										font-size: 12px;
										color: #333;
						
										span {
											font-size: 12px;
											color: #333;
										}
									}
								}
						
								.ttshop-myorderdjer {
									border-right: 1px solid #ebebeb;
								}
						
								.ttshop-shr {
									float: left;
									width: 12%;
									text-align: center;
									padding-top: 16px;
									box-sizing: border-box;
									border-right: 1px solid #ebebeb;
						
									p {
										font-size: 12px;
										color: #333;
									}
								}
						
								.ttshop-zfzje {
									float: left;
									width: 16%;
									text-align: center;
									padding-top: 16px;
									min-height: 112px;
									box-sizing: border-box;
									border-right: 1px solid #ebebeb;
						
									p {
										font-size: 12px;
										color: #333;
										margin-bottom: 8px;
						
										span {
											font-size: 12px;
											color: #333;
										}
									}
						
									strong {
										font-size: 12px;
										color: #333;
										font-weight: 400;
										cursor: pointer;
										transition: 0.5s;
										-moz-transition: 0.5s;
										-webkit-transition: 0.5s;
										-o-transition: 0.5s;
						
										&:hover {
											color: #ff0e25;
										}
									}
								}
						
								// .ttshop_qbzt {
								//   float: left;
								//   width: 15%;
								//   text-align: center;
								//   padding-top: 16px;
								//   min-height: 138px;
								//   box-sizing: border-box;
								//   border-right: 1px solid #ebebeb;
								//   .ttshop_wfk {
								//     font-size: 12px;
								//     color: #ff8500;
								//     margin-bottom: 2px;
								//   }
								//   .ttshop_cancel {
								//     font-size: 12px;
								//     color: #999;
								//     margin-bottom: 2px;
								//   }
								//   .ttshop_over {
								//     font-size: 12px;
								//     color: #333;
								//     margin-bottom: 2px;
								//   }
								//   strong {
								//     font-size: 12px;
								//     color: #ff0e25;
								//     font-weight: 400;
								//     cursor: pointer;
								//   }
								// }
						
								.ttshop-caozuo {
									float: left;
									width: 16%;
									text-align: center;
									padding-top: 16px;
									min-height: 112px;
									box-sizing: border-box;
									border-right: 1px solid #ebebeb;
						
									.ttshop-ljzf {
										display: block;
										width: 72px;
										height: 24px;
										border: 1px solid #ff3346;
										background: #fff0f1;
										line-height: 24px;
										text-align: center;
										font-size: 12px;
										color: #ff0e25;
										margin: 0 auto 8px;
										border-radius: 2px;
										cursor: pointer;
									}
						
									.ttshop-cztext {
										font-size: 12px;
										color: #333;
										margin-bottom: 8px;
										cursor: pointer;
										transition: 0.5s;
										-moz-transition: 0.5s;
										-webkit-transition: 0.5s;
										-o-transition: 0.5s;
						
										&:hover {
											color: #ff0e25;
										}
									}
						
									.ttshop-hg {
										display: block;
										width: 72px;
										height: 24px;
										background: #ebebeb;
										line-height: 24px;
										text-align: center;
										font-size: 12px;
										color: #999;
										margin: 0 auto 8px;
										border-radius: 2px;
										cursor: pointer;
										transition: 0.5s;
										-moz-transition: 0.5s;
										-webkit-transition: 0.5s;
										-o-transition: 0.5s;
						
										&:hover {
											background: #ff0e25;
											color: #fff;
										}
									}
						
									.ttshop-queren {
										display: block;
										width: 72px;
										height: 24px;
										background: #ff0e25;
										line-height: 24px;
										text-align: center;
										font-size: 12px;
										color: #fff;
										margin: 0 auto 8px;
										border-radius: 2px;
										cursor: pointer;
									}
								}
							}
						}
						
						.ttshop-caozuos {
							float: right;
							width: 24%;
							text-align: center;
							box-sizing: border-box;
							border-right: 1px solid #ebebeb;
							border-bottom: 1px solid #ebebeb;
						
							.ttshop-agree {
								width: 72px;
								height: 24px;
								line-height: 24px;
								background: rgba($color: #3FD44C, $alpha: 0.3);
								border-radius: 2px;
								border: 1px solid #3FD44C;
								font-size: 12px;
								font-family: PingFangSC-Regular, PingFang SC;
								font-weight: 400;
								color: #17CD27;
								margin-bottom: 8px;
								cursor: pointer;
							}
						
							.ttshop-refuse {
								width: 72px;
								height: 24px;
								line-height: 24px;
								background: rgba($color: #FF3346, $alpha: 0.3);
								border-radius: 2px;
								border: 1px solid #FF3346;
								font-size: 12px;
								font-family: PingFangSC-Regular, PingFang SC;
								font-weight: 400;
								color: #FF3346;
								margin-bottom: 8px;
								cursor: pointer;
							}
						
						
							.ttshop-cztexts {
								font-size: 12px;
								color: #ff0e25;
								margin-bottom: 8px;
							}
						
							.ttshop-ljzf {
								display: block;
								width: 72px;
								height: 24px;
								border: 1px solid #ff3346;
								background: #fff0f1;
								line-height: 24px;
								text-align: center;
								font-size: 12px;
								color: #ff0e25;
								margin: 0 auto 8px;
								border-radius: 2px;
								cursor: pointer;
							}
						
							.ttshop-cztext {
								font-size: 12px;
								color: #333;
								margin-bottom: 8px;
								cursor: pointer;
								transition: 0.5s;
								-moz-transition: 0.5s;
								-webkit-transition: 0.5s;
								-o-transition: 0.5s;
						
								&:hover {
									color: #ff0e25;
								}
							}
						
							.ttshop-hg {
								display: block;
								width: 72px;
								height: 24px;
								background: #ebebeb;
								line-height: 24px;
								text-align: center;
								font-size: 12px;
								color: #999;
								margin: 0 auto 8px;
								border-radius: 2px;
								cursor: pointer;
								transition: 0.5s;
								-moz-transition: 0.5s;
								-webkit-transition: 0.5s;
								-o-transition: 0.5s;
						
								&:hover {
									background: #ff0e25;
									color: #fff;
								}
							}
						
							.ttshop-queren {
								display: block;
								width: 72px;
								height: 24px;
								background: #ff0e25;
								line-height: 24px;
								text-align: center;
								font-size: 12px;
								color: #fff;
								margin: 0 auto 8px;
								border-radius: 2px;
								cursor: pointer;
							}
						}
					}
				}
			}
		}
	}
</style>
